var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgTrackList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 6.44444C4.86274 6.44444 5.4 5.89724 5.4 5.22222C5.4 4.54721 4.86274 4 4.2 4C3.53726 4 3 4.54721 3 5.22222C3 5.89724 3.53726 6.44444 4.2 6.44444Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 10.7222C4.86274 10.7222 5.4 10.175 5.4 9.49999C5.4 8.82498 4.86274 8.27777 4.2 8.27777C3.53726 8.27777 3 8.82498 3 9.49999C3 10.175 3.53726 10.7222 4.2 10.7222Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 15C4.86274 15 5.4 14.4528 5.4 13.7778C5.4 13.1028 4.86274 12.5556 4.2 12.5556C3.53726 12.5556 3 13.1028 3 13.7778C3 14.4528 3.53726 15 4.2 15Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80001 5.83334H14.4C14.5591 5.83334 14.7118 5.76895 14.8243 5.65435C14.9368 5.53974 15 5.3843 15 5.22223C15 5.06015 14.9368 4.90471 14.8243 4.7901C14.7118 4.6755 14.5591 4.61111 14.4 4.61111H7.80001C7.64088 4.61111 7.48827 4.6755 7.37575 4.7901C7.26323 4.90471 7.20001 5.06015 7.20001 5.22223C7.20001 5.3843 7.26323 5.53974 7.37575 5.65435C7.48827 5.76895 7.64088 5.83334 7.80001 5.83334Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 8.88889H7.80001C7.64088 8.88889 7.48827 8.95327 7.37575 9.06788C7.26323 9.18248 7.20001 9.33792 7.20001 9.5C7.20001 9.66207 7.26323 9.81751 7.37575 9.93212C7.48827 10.0467 7.64088 10.1111 7.80001 10.1111H14.4C14.5591 10.1111 14.7118 10.0467 14.8243 9.93212C14.9368 9.81751 15 9.66207 15 9.5C15 9.33792 14.9368 9.18248 14.8243 9.06788C14.7118 8.95327 14.5591 8.88889 14.4 8.88889Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 13.1667H7.80001C7.64088 13.1667 7.48827 13.2311 7.37575 13.3457C7.26323 13.4603 7.20001 13.6157 7.20001 13.7778C7.20001 13.9399 7.26323 14.0953 7.37575 14.2099C7.48827 14.3245 7.64088 14.3889 7.80001 14.3889H14.4C14.5591 14.3889 14.7118 14.3245 14.8243 14.2099C14.9368 14.0953 15 13.9399 15 13.7778C15 13.6157 14.9368 13.4603 14.8243 13.3457C14.7118 13.2311 14.5591 13.1667 14.4 13.1667Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgTrackList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/track-list.8d8727cfa007b101e2966c78efc7f8df.svg";